import { render, staticRenderFns } from "./ManagerDetails.vue?vue&type=template&id=057781b4&scoped=true&"
import script from "./ManagerDetails.vue?vue&type=script&lang=js&"
export * from "./ManagerDetails.vue?vue&type=script&lang=js&"
import style0 from "./ManagerDetails.vue?vue&type=style&index=0&id=057781b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057781b4",
  null
  
)

export default component.exports